import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';

import Countdown from './Countdown';
import DownloadProgram from './DownloadProgram';
import WhatsappButton from './WhatsappButton';

import config from './config';

// Utilities
import Sticky from './common/stickyHeader';
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

// Render the "Countdown" component
ReactDOM.render((
  <Countdown />
), document.getElementById('countdown'));

// Render the "Download Program" link
ReactDOM.render((
  <CookiesProvider>
    <DownloadProgram config={config} />
  </CookiesProvider>
), document.getElementById('downloadProgramRoot'));

// Render the "Whatsapp" button
ReactDOM.render((
  <WhatsappButton config={config} />
), document.getElementById('whatsapp'));

(() => {
  (new Sticky(document.getElementById('header'), 'bg-white shadow-lg')).init();

  // Testimonials slider
  tns({
    container: '#testimonials',
    items: 1,
    slideBy: 'page',
    mode: 'gallery',
    autplay: true,
    controls: false,
    nav: true,
    navPosition: 'bottom',
  });
})();
